import { Link } from 'react-router-dom';

const footerColumns = [
  {
    title: '热门分类',
    links: [
      { label: '校园恋爱', path: '/category/school-romance' },
      { label: '奇幻冒险', path: '/category/fantasy' },
      { label: '热血动作', path: '/category/action' },
      { label: '悬疑惊悚', path: '/category/thriller' },
    ],
  },
  {
    title: '推荐作品',
    links: [
      { label: '女神的贴身高手', path: '/comic/goddess-bodyguard' },
      { label: '重生之都市修仙', path: '/comic/urban-cultivation' },
      { label: '我独自升级', path: '/comic/solo-leveling' },
      { label: '公爵的契约未婚妻', path: '/comic/duke-fiancee' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '阅读指南', path: '/about' },
      { label: '常见问题', path: '/about' },
      { label: '反馈建议', path: '/about#contact' },
      { label: '合作联系', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#06060A] border-t border-comic-border" role="contentinfo">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* 上部：四列链接 */}
        <div className="py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-white text-sm font-bold mb-4">
                <a href="#" className="hover:text-comic-primary transition-colors">
                  {col.title}
                </a>
              </h4>
              <div className="w-8 h-px bg-comic-border mb-4"></div>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-gray-400 text-sm hover:text-comic-primary transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* 底部区域 */}
        <div className="border-t border-comic-border py-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
            {/* 左侧大字品牌 */}
            <div className="flex items-baseline gap-3">
              <span className="text-4xl md:text-6xl font-display font-black text-white leading-none">
                韩漫
              </span>
              <span className="text-4xl md:text-6xl font-display font-black text-comic-primary leading-none">
                大全
              </span>
            </div>

            {/* 中间说明 */}
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-comic-border"></div>
              <p className="text-gray-500 text-xs max-w-xs leading-relaxed">
                韩国漫画网 — 免费高清韩漫在线阅读平台，每日更新最新热门作品，为漫画爱好者提供极致阅读体验。
              </p>
            </div>

            {/* 右侧版权和社交 */}
            <div className="flex flex-col items-start lg:items-end gap-4">
              <p className="text-gray-500 text-xs">
                &copy; {new Date().getFullYear()} 韩国漫画网 KMANHUA. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-comic-primary hover:border-comic-primary transition-all duration-200"
                  aria-label="微博"
                  rel="nofollow"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-comic-primary hover:border-comic-primary transition-all duration-200"
                  aria-label="微信"
                  rel="nofollow"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-comic-primary hover:border-comic-primary transition-all duration-200"
                  aria-label="B站"
                  rel="nofollow"
                >
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-comic-border text-gray-400 hover:text-comic-primary hover:border-comic-primary transition-all duration-200"
                  aria-label="小红书"
                  rel="nofollow"
                >
                  <i className="ri-reddit-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}